import React from "react";
import { TableIcon } from "lucide-react";
import { WorkspaceSwitcher } from "@header/WorkspaceSwitcher";

export const CrmSidebar = () => {
  return (
    <aside
      className="w-56 shrink-0 flex flex-col relative overflow-hidden"
      style={{ background: '#132321', borderRight: '1px solid rgba(51,184,100,0.15)' }}
    >
      {/* Dot-grid texture */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.03]"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)',
          backgroundSize: '24px 24px',
        }}
      />
      {/* Top green accent line */}
      <div className="h-[2px] w-full flex-shrink-0" style={{ background: 'linear-gradient(90deg, #33b864, transparent)' }} />

      {/* Workspace switcher */}
      <div className="pt-3 relative z-10">
        <WorkspaceSwitcher />
      </div>

      {/* Section label */}
      <div className="px-4 py-3 relative z-10" style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
        <p
          className="text-[9px] font-bold uppercase tracking-[0.12em]"
          style={{ color: 'rgba(255,255,255,0.35)' }}
        >
          Tables
        </p>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto p-2 space-y-0.5 relative z-10">
        <div
          className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left rounded-lg relative"
          style={{
            background: 'rgba(51,184,100,0.14)',
            color: '#33b864',
            fontWeight: 600,
          }}
        >
          <div
            className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-5 rounded-r-full"
            style={{ background: '#33b864' }}
          />
          <TableIcon className="h-3.5 w-3.5 shrink-0" style={{ color: '#33b864' }} />
          <span className="truncate">Clients</span>
        </div>
      </nav>
    </aside>
  );
};
